import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type CustomerLayoutMode = 'grid' | 'list' | 'table';

interface CustomersUiStore {
  layoutMode: CustomerLayoutMode;
  setLayoutMode: (mode: CustomerLayoutMode) => void;
}

export const useCustomersUiStore = create<CustomersUiStore>()(
  persist(
    (set) => ({
      layoutMode: 'grid',
      setLayoutMode: (layoutMode) => set({ layoutMode }),
    }),
    {
      name: 'customers-ui-prefs',
      storage: createJSONStorage(() => localStorage),
      merge: (persisted, current) => {
        const p = (persisted || {}) as Partial<CustomersUiStore>;
        const mode = p.layoutMode;
        const layoutMode: CustomerLayoutMode =
          mode === 'grid' || mode === 'list' || mode === 'table' ? mode : current.layoutMode;
        return { ...current, ...p, layoutMode };
      },
    },
  ),
);
